// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__ZdM4u","listContainer":"ContactList_listContainer__FDIiM"};